export type UmpireSoccerMatchHalf = 1 | 2;
